'use client';
import React from 'react';
import DimmedLayer from '../../common/DimmedLayer.mjs';
import FixedLayer from '../FixedLayer.mjs';
import ModalFrame from '../ModalFrame.mjs';
import { MODAL_CATEGORY } from '../../../constants/modal.mjs';
import { useModalStore, useTopModal, modalInternal } from '../../../contexts/ModalContext.mjs';
import useApplyLogging from '../../../hooks/useApplyLogging.mjs';
import usePortal from '../../../hooks/usePortal.mjs';

function TopModal(_ref) {
  let {
    isPreRender,
    children,
    onClickCloseButton,
    onClickDimmedLayer,
    closeButtonText,
    isShowCloseButton,
    customClassName,
    role,
    ...props
  } = _ref;
  useApplyLogging('TopModal');
  const {
    modals
  } = useModalStore();
  const {
    close
  } = useTopModal();
  const centerModal = modals.find(m => m.category === MODAL_CATEGORY.TOP);
  const {
    isOpen = false,
    isShow = false,
    toBeDestroyed = false
  } = centerModal ?? {};
  const handleTransitionEnd = () => toBeDestroyed && modalInternal.destroy(MODAL_CATEGORY.TOP);
  const Portal = usePortal();
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(FixedLayer, {
    isPreRender: isPreRender,
    direction: "top",
    ...(isOpen ? {
      tabIndex: 0
    } : {})
  }, /*#__PURE__*/React.createElement(ModalFrame, {
    direction: "top",
    isShow: isShow,
    isShowCloseButton: isShowCloseButton,
    closeButtonText: closeButtonText,
    onClickCloseButton: onClickCloseButton,
    close: close,
    customClassName: customClassName,
    role: role,
    onTransitionEnd: handleTransitionEnd,
    ...props
  }, children), /*#__PURE__*/React.createElement(DimmedLayer, {
    isShow: isShow,
    onClick: onClickDimmedLayer ?? close
  })));
}
TopModal.displayName = 'TopModal';

export { TopModal as default };
